import type { NextPage } from "next";
import { FAQPage, WithContext } from "schema-dts";

import { getModifiedDate } from "lib/helpers";

import DemoFormSection from "components/demo-form-section";
import FAQJsonLD from "components/views/faq/json-ld";
import FAQSections from "components/views/faq/sections";
import TableOfContents from "components/views/faq/table-of-contents";

import Page from "../../components/layout/page";
import MainHero from "../../components/views/faq/main-hero";

type FAQProps = { jsonLd: WithContext<FAQPage> };

const FAQ: NextPage<FAQProps> = ({ jsonLd }) => {
  return (
    <Page
      title="Enerflo FAQ | Solar Platform Features, Pricing & Integrations"
      description="Get answers to common questions about Enerflo’s solar platform. Learn how Enerflo helps sales dealers, installers, and homeowners streamline solar projects, integrate tools, reduce costs, and close more deals."
    >
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <MainHero />
      <TableOfContents />
      <FAQSections />
      <DemoFormSection />
    </Page>
  );
};

export default FAQ;

export async function getStaticProps() {
  const jsonLd: WithContext<FAQPage> = {
    ...FAQJsonLD,
    dateModified: getModifiedDate(),
  };

  return {
    props: {
      jsonLd,
    },
  };
}
